<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Tipos de Observadores</h3>
        </div>

        <!-- Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Tipos de observadores</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6 class="m-0">
                  {{ pagination.TotalItems | number }}
                  {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                </h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">Nome</th>
                    <th scope="col" class="border-0">Intervalo de execução</th>
                    <th scope="col" class="border-0">Identificador</th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(watcher, index) in watcherTypes" :key="index">
                    <td></td>
                    <td class="text-left">{{ watcher.Name }}</td>
                    <td>{{ GetDDHHmm(watcher.Time, "DDHHmm") }}</td>
                    <td>{{ watcher.Id }}</td>
                    <td></td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            v-if="$isAuthorize('WatcherType', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenWatcherType($event, index, true)"
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            class="dropdown-item"
                            v-if="
                              !watcher.IsExcluded &&
                              $isAuthorize('WatcherType', 'Update')
                            "
                            href="#"
                            v-on:click="OpenWatcherType($event, index)"
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a
                            class="dropdown-item"
                            v-if="
                              !watcher.IsExcluded &&
                              $isAuthorize('WatcherType', 'Delete')
                            "
                            href="#"
                            v-on:click="
                              ConfirmRemoveWatcherType(watcher.Name, watcher.Id)
                            "
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      watcherTypes == undefined ||
                      watcherTypes == null ||
                      watcherTypes.length == 0
                    "
                  >
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
      :title="modalTitle"
      id="mFormWatcherType"
      size="md"
    >
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <div v-else>
        <!-- Name -->
        <ValidationObserver tag="form" ref="WatcherValidationForm">
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>Nome</label>
              <ValidationProvider
                rules="required|min:3"
                v-slot="{ errors, invalid }"
              >
                <b-input
                  :class="validatedWatcherForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                  type="text"
                  v-model="infoWatcherType.Name"
                ></b-input>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedWatcherForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>

          <!-- Time (Interval) in minutes -->
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>
                Intervalo
                <i
                  class="far fa-question-circle ml-1"
                  style="font-size: 13px"
                  v-b-tooltip.hover.bottom
                  title="Valor que será considerado (em MINUTOS). Utilize os campos abaixo para o cálculo automático."
                >
                </i>
              </label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <b-input
                  :class="validatedWatcherForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                  min="0"
                  step="1"
                  type="number"
                  v-model="infoWatcherType.Time"
                ></b-input>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedWatcherForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>

          <!-- Days -->
          <d-form-row>
            <d-col md="4" class="form-group">
              <label>Dias</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <b-input
                  :class="validatedWatcherForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                  @keypress="preventDecimal"
                  min="0"
                  step="1"
                  type="number"
                  v-model="Watcher.Time.Days"
                ></b-input>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedWatcherForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>

            <!-- Hours -->
            <d-col md="4" class="form-group">
              <label>Horas</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <b-input
                  :class="validatedWatcherForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                  @keypress="preventDecimal"
                  min="0"
                  max="24"
                  step="1"
                  type="number"
                  v-model="Watcher.Time.Hours"
                ></b-input>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedWatcherForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>

            <!-- Minutes -->
            <d-col md="4" class="form-group">
              <label>Minutos</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <b-input
                  :class="validatedWatcherForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                  @keypress="preventDecimal"
                  min="0"
                  max="60"
                  step="1"
                  type="number"
                  v-model="Watcher.Time.Minutes"
                ></b-input>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedWatcherForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="SaveWatcherType()"
          v-if="!isSeeing || (isSeeing && loadingAddUpdate)"
          :disabled="loadingAddUpdate || loadingModal"
        >
          <template v-if="!loadingAddUpdate">
            {{ pOpened != null ? " Salvar" : " Adicionar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
      centered
      id="mFilter"
      title="Filtros"
    >
      <d-form-row>
        <d-col md="12" class="form-group">
          <input
            class="form-control"
            placeholder="Nome"
            type="text"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
      </d-form-row>

      <d-form-row>
        <d-col md="12" class="form-group">
          <d-select v-model="filter.IsExcluded" :value="false">
            <option :value="true" selected>Removidos</option>
            <option :value="false" selected>Ativos</option>
          </d-select>
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          @click="Filter()"
          class="btn btn-primary"
          title="Pesquisar"
          v-b-tooltip.hover.bottom
          variant="primary"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          @click="ResetFilter()"
          class="input-group-text"
          title="Limpar filtros"
          v-b-tooltip.hover.bottom
          variant="primary"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('WatcherType', 'Add')"
      class="btn-float success"
      href="#"
      title="Novo tipo de observador"
      v-b-tooltip.hover
      v-on:click="OpenWatcherType($event)"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";

export default {
  name: "watcherTypes",
  data: function () {
    return {
      countFilter: 0,
      watcherTypes: [],
      filter: {
        Description: null,
        IsExcluded: false,
      },
      idWatcher: 0,
      infoWatcherType: {
        Name: null,
        Time: null,
      },
      isSeeing: false,
      loadingAddUpdate: false,
      loadingList: false,
      loadingModal: false,
      loadingTimers: false,
      modalTitle: "Novo Tipo de observador",
      pOpened: null,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0,
      },
      validatedWatcherForm: false,
      Watcher: {
        Time: {
          Days: 0,
          Hours: 0,
          Minutes: 0,
        },
      },
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListWatcherType();
    },
    "pagination.RowsPerPage": function () {
      this.ListWatcherType();
    },
    "infoWatcherType.Time": function (nv, ov) {
      if (nv != null && nv != 0 && (ov === null || ov === 0)) {
        // Just when modal is loading an existent WatcherType.
        const dhm = this.GetDDHHmm(nv, "object");
        this.Watcher.Time.Days = dhm.days;
        this.Watcher.Time.Hours = dhm.hours;
        this.Watcher.Time.Minutes = dhm.minutes;
      }
    },
    "Watcher.Time.Days": function () {
      this.RefreshInterval();
    },
    "Watcher.Time.Hours": function () {
      this.RefreshInterval();
    },
    "Watcher.Time.Minutes": function () {
      this.RefreshInterval();
    },
  },
  beforeMount() {
    this.ListWatcherType();
  },
  mounted() {
    this.ListWatcherType();
  },
  methods: {
    IsOnSelectedFieldList: function (Id) {
      let result = this.infoWatcherType.Fields.find((elm) => {
        return elm.Id == Id;
      });
      return result == undefined ? false : true;
    },
    GetDDHHmm: function (totalMinutes, format = "object") {
      const decml_days = totalMinutes / 60 / 24;
      const day_has_decimal =
        decml_days.toPrecision().split(".").length > 1 ? true : false;
      var days = parseInt(decml_days.toPrecision().split(".")[0]);
      var hours = 0;
      var minutes = 0;

      if (day_has_decimal) {
        const decml_hours =
          parseFloat("0." + decml_days.toPrecision().split(".")[1]) * 24;
        const hr_has_decimal =
          decml_hours.toPrecision().split(".").length > 1 ? true : false;
        hours = parseInt(decml_hours.toPrecision().split(".")[0]);

        if (hr_has_decimal) {
          const decml_minutes =
            parseFloat("0." + decml_hours.toPrecision().split(".")[1]) * 60;
          minutes = parseInt(decml_minutes.toPrecision().split(".")[0]);
        }
      }
      if (format === "DDHHmm") {
        let retData = "";
        if (days > 0) retData += days + "d ";
        if (hours > 0) retData += hours + "hr ";
        if (minutes > 0) retData += minutes + "min";

        return retData;
      }
      if (format === "object") {
        return {
          days,
          hours,
          minutes,
        };
      }
    },
    OpenWatcherType: function (e, i, view) {
      e.preventDefault();
      this.validatedWatcherForm = false;
      this.ResetInfoWatcherType();

      if (view == undefined && i != undefined) {
        // Edit
        this.pOpened = i;
        this.idWatcher = this.watcherTypes[i].Id;
        this.isSeeing = false;
        this.modalTitle = "Editar tipo de observador";
        this.GetWatcherType();
      } else if (view == undefined && i == undefined) {
        // Add new
        this.pOpened = null;
        this.isSeeing = false;
        this.modalTitle = "Novo tipo de observador";
        this.ResetInfoWatcherType();
      } else {
        // View
        this.pOpened = i;
        this.idWatcher = this.watcherTypes[i].Id;
        this.isSeeing = true;
        this.modalTitle = "Detalhes do tipo de observador";
        this.GetWatcherType();
      }
      this.$bvModal.show("mFormWatcherType");
    },
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    preventDecimal(e) {
      if (
        e.code == "Comma" ||
        e.code == "Period" ||
        e.code == "Minus" ||
        e.code == "Equal"
      ) {
        e.preventDefault();
      }
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListWatcherType();
    },
    RefreshInterval: function () {
      const int_days = parseInt(this.Watcher.Time.Days || 0);
      const int_hours = parseInt(this.Watcher.Time.Hours || 0);
      const int_minutes = parseInt(this.Watcher.Time.Minutes || 0);

      const daysInHours = Math.round(int_days * 24);
      const hoursInMinutes = Math.round((int_hours + daysInHours) * 60);
      const resultingMinutes = Math.round(hoursInMinutes + int_minutes);
      this.infoWatcherType.Time = resultingMinutes;
    },
    ResetFilter: function () {
      this.filter = {
        Description: null,
        IsExcluded: false,
      };
      this.ListWatcherType();
    },
    ResetInfoWatcherType: function () {
      this.infoWatcherType = {
        Name: null,
        Time: null,
      };
      this.Watcher = {
        Time: {
          Days: 0,
          Hours: 0,
          Minutes: 0,
        },
      };
    },
    SaveWatcherType: function () {
      this.validatedWatcherForm = true;
      this.$refs.WatcherValidationForm.validate().then((isValid) => {
        if (isValid) {
          this.loadingAddUpdate = true;
          this.isSeeing = true;

          if (this.pOpened == null) {
            // Add
            this.$store
              .dispatch("AddWatcherType", this.infoWatcherType)
              .then(() => {
                this.$makeToast(
                  "O tipo de observador foi cadastrado com sucesso.",
                  "success",
                  "Tipo de observador cadastrado"
                );
                this.ListWatcherType();
                this.$bvModal.hide("mFormWatcherType");
              })
              .catch((error) => {
                this.$makeToast(
                  "Tente novamente mais tarde.",
                  "danger",
                  "Erro ao criar observador cadastrado",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          } else {
            // Update
            this.$store
              .dispatch("UpdateWatcherType", this.infoWatcherType)
              .then(() => {
                this.$makeToast(
                  "O tipo de observador foi atualizado.",
                  "success",
                  "Atualizado"
                );
                this.ListWatcherType();
                this.$bvModal.hide("mFormWatcherType");
              })
              .catch((error) => {
                this.$makeToast(
                  "Erro ao atualizar o tipo de observador, tente novamente.",
                  "danger",
                  "Erro ao modificar tipo de observador",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          }
        }
      });
    },
    GetWatcherType: function () {
      if (this.idWatcher != 0) {
        this.loadingModal = true;
        this.$store
          .dispatch("GetWatcherType", { id: this.idWatcher })
          .then((response) => {
            this.infoWatcherType = response;
          })
          .catch((error) => {
            this.$makeToast(
              "Um erro ocorreu ao carregar o tipo de observador",
              "danger",
              "Erro ao carregar o tipo de observador",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    ListWatcherType: function () {
      this.loadingList = true;
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.IsExcluded)) this.countFilter++;
      let data = {
        ...this.pagination,
        "Object.IsExcluded": this.filter.IsExcluded,
        "Object.Name": this.filter.Name,
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListWatcherType", { params: data })
        .then((response) => {
          this.watcherTypes = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            "Um erro ocorreu ao listar os tipos de observadores. Tente novamente.",
            "danger",
            "Erro ao listar os tipos de observadores",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    ConfirmRemoveWatcherType: function (description, id) {
      this.$makeMsgBox(
        `Deseja remover "${description}" ?`,
        "Confirmar",
        this.DeleteWatcherType,
        id
      );
    },
    DeleteWatcherType: function (id) {
      this.$store
        .dispatch("DeleteWatcherType", { id: id })
        .then(() => {
          this.$makeToast(
            "O tipo de observador foi removido com sucesso.",
            "success",
            "Removido com sucesso"
          );
          this.ListWatcherType();
          this.$bvModal.hide("mFormWatcherType");
        })
        .catch((error) => {
          this.$makeToast(
            "Tente novamente.",
            "danger",
            "Erro ao remover tipo de observador",
            error
          );
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/watcherTypes.vue